var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackLogo = function SvgSlackLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M34.135 18.654a3.365 3.365 0 1 0-3.366-3.365v3.365zm-9.423 0a3.365 3.365 0 0 0 3.365-3.366V5.866a3.365 3.365 0 0 0-6.73 0v9.422a3.365 3.365 0 0 0 3.365 3.366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M5.865 21.346a3.365 3.365 0 1 0 3.366 3.365v-3.365zm9.423 0a3.365 3.365 0 0 0-3.365 3.366v9.422a3.365 3.365 0 0 0 6.73 0v-9.422a3.365 3.365 0 0 0-3.365-3.366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M21.346 34.135a3.365 3.365 0 1 0 3.365-3.366h-3.364zm0-9.423a3.365 3.365 0 0 0 3.366 3.365h9.422a3.365 3.365 0 0 0 0-6.73h-9.422a3.365 3.365 0 0 0-3.366 3.365"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M18.654 5.865a3.365 3.365 0 1 0-3.365 3.366h3.365zm0 9.423a3.365 3.365 0 0 0-3.366-3.365H5.866a3.365 3.365 0 0 0 0 6.73h9.422a3.365 3.365 0 0 0 3.366-3.365"
  })));
};
export default SvgSlackLogo;